import axiosInstance from "../../axiosInstance";
const BASE_URL = "/hrm/overtimes";

// ✅ Lấy danh sách tăng ca
export const getAllOvertimes = async (params = {}) => {
  try {
    const response = await axiosInstance.get(BASE_URL, { params, withCredentials: true });
    return response.data;
  } catch (error) {
    console.error("Error fetching overtimes:", error);
    throw error;
  }
};

// Lấy danh sách chờ duyệt — NÊN TRẢ CẢ LEVEL 2
export const getPendingOvertimes = async (params = {}) => {
  try{
    const response = await axiosInstance.get(`${BASE_URL}/pending`, { params });
    return response.data;
  } catch (error) {
    console.error("Lỗi chi tiết:", error.response?.data || error.message);
    throw error;
  }
};


// Lấy danh sách phiếu đang thực hiện — CHỜ BÁO CÁO
export const getRunningOvertimes = async (params = {}) => {
  try {
    const response = await axiosInstance.get(`${BASE_URL}/running`, { params });
    return response.data;
  } catch (error) {
    console.error("Lỗi chi tiết:", error.response?.data || error.message);
    throw error;
  }
};

// Lấy danh sách phiếu đang chờ review (dành cho sếp)
export const getWaitingReviewOvertimes = async (params = {}) => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}/waiting-review`, { params });
    return res.data;
  } catch (error) {
    console.error("Lỗi:", error.response?.data || error.message);
    throw error;
  }
};



// 🔥 Inbox dành cho sếp → Phiếu đang chờ tôi duyệt
export const getApprovalInbox = async () => {
  try{
    const response = await axiosInstance.get(`${BASE_URL}/inbox`);
    return response.data;
  } catch (error) {
    console.error("Lỗi chi tiết:", error.response?.data || error.message);
    throw error;
  };
};


// ✅ Đăng ký tăng ca mới
export const createOvertime = async (payload) => {
  try{
    const response = await axiosInstance.post(BASE_URL, payload);
    return response.data;
  } catch (error) {
    console.error("Lỗi chi tiết:", error.response?.data || error.message);
    throw error;
  };
};

// approveOvertime → cần truyền level vào BE
export const approveOvertime = async (id, data) => {
  try{
    const response = await axiosInstance.put(`${BASE_URL}/${id}/approve`, data);
    return response.data;
  } catch (error) {
    console.error("Lỗi chi tiết:", error.response?.data || error.message);
    throw error;
  };
};

// ✅ Từ chối tăng ca
export const rejectOvertime = async (id, approver_id, reason) => {
  try{
    const response = await axiosInstance.put(`${BASE_URL}/${id}/reject`, {
      approver_id,
      reason,
    });
    return response.data;
  } catch (error) {
    console.error("Lỗi chi tiết:", error.response?.data || error.message);
    throw error;
  };
};


// ======================================================
// 📤 UPLOAD FILE BÁO CÁO (PDF / IMAGE)
// ======================================================
export const uploadOvertimeReportFile = async (file, otId) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const response = await axiosInstance.post(
      `${BASE_URL}/${otId}/upload-report-file`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }
    );

    return response.data;  // { file_url, file_name }
  } catch (error) {
    console.error("Upload file báo cáo lỗi:", error);
    throw error;
  }
};


// 📝 Nhân viên gửi báo cáo tăng ca (file + mô tả)
export const submitOvertimeReport = async (id, payload) => {
  try {
    const response = await axiosInstance.put(`${BASE_URL}/${id}/report`, payload);
    return response.data;
  } catch (error) {
    console.error("Lỗi chi tiết:", error.response?.data || error.message);
    throw error;
  }
};

// ⭐ Review & hoàn tất phiếu tăng ca
export const reviewOvertime = async (id, payload) => {
  try{
    const response = await axiosInstance.put(`${BASE_URL}/${id}/review`, payload);
    return response.data;
  } catch (error) {
    console.error("Lỗi chi tiết:", error.response?.data || error.message);
    throw error;
  };
};

// ✅ Xóa đăng ký tăng ca
export const deleteOvertime = async (id) => {
  try{
    const response = await axiosInstance.delete(`${BASE_URL}/${id}`);
    return response.data;
  } catch (error) {
    console.error("Lỗi chi tiết:", error.response?.data || error.message);
    throw error;
  };
};

// ✅ Export CSV tăng ca (chuẩn BE)
export const exportOvertimeCsv = async (params = {}) => {
  try {
    const response = await axiosInstance.get(
      `${BASE_URL}/export-csv`,
      {
        params,
        responseType: "blob", // 🔥 bắt buộc để nhận file
        withCredentials: true
      }
    );

    return response.data; // blob file
  } catch (error) {
    console.error("Lỗi export CSV:", error.response?.data || error.message);
    throw error;
  }
};